/* Holy grails. Liquid (snippets/grail.liquid) markerer grails med data-grail="1-4" ("0" = under minimumsprisen). Her:
   1) niveau i fremmed valuta (data-grail tomt) ud fra Shopify.currency.rate, inkl. minimumsprisen,
   2) farverne --grail-c1/--grail-c2 fra produktbilledet,
   3) billeder paa hvid baggrund: troejen klippes fri i hoej oploesning (bloed kant uden hvid glorie) og saettes paa et
      moenster i daempede udgaver af sine egne farver, som i Canva-skabelonen. Billeder med egen baggrund roeres ikke. */
(() => {
  const cfg = window.sfsGrails || { tiers: [4000, 10000, 20000], min: 2499 };
  const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  const SAMPLE = 600;

  function tierOf(host) {
    if (!host.dataset.grail) {
      // ponytail: omregnede priser rundes op (fx til ,95 i EUR), saa 19.999 kr kommer tilbage som ca. 20.003 kr.
      // 0,5 % afslag holder x.999-priser under graensen; en pris lige praecis paa graensen kan ende et niveau for lavt
      // i fremmed valuta. Skal det vaere eksakt, saa saet niveauet som tag (fx med Flow) i stedet for at regne det her.
      // Minimumsprisen uden afslag, ellers falder en troeje til praecis 2.499 kr ud i EUR.
      const raw = Number(host.dataset.grailPrice) / 100 / rate, kr = raw * 0.995;
      const t = cfg.tiers;
      host.dataset.grail = raw < (cfg.min || 0) ? 0 : kr >= t[2] ? 4 : kr >= t[1] ? 3 : kr >= t[0] ? 2 : 1;
    }
    return Number(host.dataset.grail);
  }

  // De to hyppigste farver der er tydeligt forskellige. Mangler nr. 2, bliver den hvid.
  function dominant(d, keep, step) {
    const count = new Uint32Array(512), sum = new Float64Array(512 * 3);
    let total = 0;
    for (let i = 0; i < d.length; i += 4 * step) {
      if (!keep(i)) continue;
      const k = ((d[i] >> 5) << 6) | ((d[i + 1] >> 5) << 3) | (d[i + 2] >> 5);
      count[k]++; sum[k * 3] += d[i]; sum[k * 3 + 1] += d[i + 1]; sum[k * 3 + 2] += d[i + 2];
      total++;
    }
    const order = [...count.keys()].sort((a, b) => count[b] - count[a]);
    const mean = (k) => [0, 1, 2].map((c) => Math.round(sum[k * 3 + c] / count[k]));
    const c1 = mean(order[0]);
    let c2 = [250, 250, 250];
    for (const k of order.slice(1, 12)) {
      if (count[k] / total < 0.04) break;
      const c = mean(k);
      if (Math.hypot(c[0] - c1[0], c[1] - c1[1], c[2] - c1[2]) > 110) { c2 = c; break; }
    }
    return [c1, c2];
  }

  function pixels(src, w, h) {
    const canvas = document.createElement('canvas');
    canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(src, 0, 0, w, h);
    try { return { canvas, ctx, data: ctx.getImageData(0, 0, w, h) }; } catch (e) { return null; }
  }

  function borderOf(w, h) {
    const border = [];
    for (let x = 0; x < w; x++) border.push(x, (h - 1) * w + x);
    for (let y = 1; y < h - 1; y++) border.push(y * w, y * w + w - 1);
    return border;
  }

  // Hurtig maaling paa det billede der allerede er hentet: har det hvid baggrund, og hvilke farver har troejen.
  function sample(img) {
    const s = Math.min(1, SAMPLE / img.naturalWidth);
    const w = Math.round(img.naturalWidth * s), h = Math.round(img.naturalHeight * s);
    const px = pixels(img, w, h);
    if (!px) return null;
    const d = px.data.data, n = w * h, border = borderOf(w, h);
    const light = (p) => {
      const i = p * 4, mn = Math.min(d[i], d[i + 1], d[i + 2]), mx = Math.max(d[i], d[i + 1], d[i + 2]);
      return mn >= 232 && mx - mn <= 16 && d[i + 3] > 200;
    };
    const whiteShare = border.reduce((a, p) => a + (light(p) ? 1 : 0), 0) / border.length;
    if (whiteShare < 0.85) {
      const onBorder = new Uint8Array(n);
      border.forEach((p) => { onBorder[p] = 1; });
      // Canva-billederne har hvide striber i kanten; hvid maa ikke blive hovedfarven.
      const colors = dominant(d, (i) => onBorder[i / 4], 1);
      if (lum(colors[0]) > 205 && lum(colors[1]) <= 205) colors.reverse();
      return { white: false, colors };
    }
    // Troejens farver: alt der ikke ligner baggrunden.
    return { white: true, colors: dominant(d, (i) => !light(i / 4) && d[i + 3] > 200, 2) };
  }

  // Frilaegning i fuld oploesning. Baggrunden er det der haenger sammen med kanten og ligner kantens farve; kanten
  // faar en bloed overgang, og den hvide farve der er blandet ind i kantpixels traekkes ud igen, saa der ikke er en lys rand.
  function cutout(src) {
    const w = src.naturalWidth, h = src.naturalHeight, n = w * h;
    const px = pixels(src, w, h);
    if (!px) return null;
    const d = px.data.data, border = borderOf(w, h);

    const med = [0, 1, 2].map((c) => {
      const v = border.map((p) => d[p * 4 + c]).sort((a, b) => a - b);
      return v[v.length >> 1];
    });
    const dist = new Uint8Array(n);
    for (let p = 0, i = 0; p < n; p++, i += 4) {
      dist[p] = Math.max(Math.abs(d[i] - med[0]), Math.abs(d[i + 1] - med[1]), Math.abs(d[i + 2] - med[2]));
    }
    const LOW = 14, HIGH = 64;
    const bgLike = (p) => {
      const i = p * 4;
      return dist[p] <= 24 && Math.max(d[i], d[i + 1], d[i + 2]) - Math.min(d[i], d[i + 1], d[i + 2]) <= 20;
    };

    const removed = new Uint8Array(n), queue = new Int32Array(n);
    let head = 0, tail = 0;
    border.forEach((p) => { if (bgLike(p) && !removed[p]) { removed[p] = 1; queue[tail++] = p; } });
    while (head < tail) {
      const p = queue[head++], x = p % w;
      if (x > 0 && !removed[p - 1] && bgLike(p - 1)) { removed[p - 1] = 1; queue[tail++] = p - 1; }
      if (x < w - 1 && !removed[p + 1] && bgLike(p + 1)) { removed[p + 1] = 1; queue[tail++] = p + 1; }
      if (p >= w && !removed[p - w] && bgLike(p - w)) { removed[p - w] = 1; queue[tail++] = p - w; }
      if (p < n - w && !removed[p + w] && bgLike(p + w)) { removed[p + w] = 1; queue[tail++] = p + w; }
    }

    // Kantbaand: 3 px ind i troejen fra den fjernede baggrund.
    const band = new Uint8Array(n);
    let front = [];
    for (let p = 0; p < n; p++) {
      if (removed[p]) continue;
      const x = p % w;
      if ((x > 0 && removed[p - 1]) || (x < w - 1 && removed[p + 1]) || (p >= w && removed[p - w]) || (p < n - w && removed[p + w])) {
        band[p] = 1; front.push(p);
      }
    }
    for (let ring = 2; ring <= 3; ring++) {
      const next = [];
      front.forEach((p) => {
        const x = p % w;
        [x > 0 ? p - 1 : -1, x < w - 1 ? p + 1 : -1, p - w, p + w].forEach((q) => {
          if (q >= 0 && q < n && !removed[q] && !band[q]) { band[q] = ring; next.push(q); }
        });
      });
      front = next;
    }

    const alpha = new Float32Array(n);
    for (let p = 0; p < n; p++) {
      if (removed[p]) alpha[p] = 0;
      else if (band[p]) alpha[p] = Math.min(1, Math.max(0, (dist[p] - LOW) / (HIGH - LOW)));
      else alpha[p] = 1;
    }
    // Bloed overgang: 3x3-gennemsnit af alfa paa yderste ring, saa kanten ikke bliver takket.
    const soft = alpha.slice();
    for (let p = 0; p < n; p++) {
      if (band[p] !== 1) continue;
      const x = p % w;
      let s = 0, c = 0;
      for (let dy = -1; dy <= 1; dy++) {
        for (let dx = -1; dx <= 1; dx++) {
          const xx = x + dx, q = p + dy * w + dx;
          if (xx < 0 || xx >= w || q < 0 || q >= n) continue;
          s += alpha[q]; c++;
        }
      }
      soft[p] = Math.min(alpha[p], s / c);
    }
    for (let p = 0, i = 0; p < n; p++, i += 4) {
      const a = soft[p];
      if (a <= 0.02) { d[i + 3] = 0; continue; }
      if (band[p]) {
        // Traek baggrundsfarven ud af kantpixlen: c = bg + (c - bg) / a.
        for (let c = 0; c < 3; c++) d[i + c] = Math.max(0, Math.min(255, Math.round(med[c] + (d[i + c] - med[c]) / a)));
      }
      d[i + 3] = Math.round(a * 255);
    }
    px.ctx.putImageData(px.data, 0, 0);
    return px.canvas;
  }

  const mix = (c, to, f) => c.map((v, k) => Math.round(v * (1 - f) + to[k] * f));
  const grey = (c, f) => { const g = (c[0] + c[1] + c[2]) / 3; return c.map((v) => Math.round(v * (1 - f) + g * f)); };
  const lum = (c) => 0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2];
  const css = (c) => `rgb(${c.join(',')})`;

  // Som Canva-skabelonen: en daempet, lysere udgave af troejens farve og en koksgraa, saa troejen staar frem.
  function palette([c1, c2]) {
    let base = c1;
    if (lum(c1) > 205) base = lum(c2) > 205 ? [200, 200, 200] : c2;
    const a = grey(mix(base, [255, 255, 255], 0.32), 0.3);
    const dark = lum(c2) < 90 && base !== c2 ? c2 : base;
    const b = mix(grey(dark, 0.4), [34, 34, 34], 0.72);
    return [a, b];
  }

  // Moenstret bliver vildere jo hoejere niveau: lodrette striber, skraa striber, solstraaler, solstraaler med moerk kant.
  function paint(cut, tier, colors) {
    const W = cut.width, H = cut.height;
    const out = document.createElement('canvas');
    out.width = W; out.height = H;
    const ctx = out.getContext('2d');
    const [a, b] = palette(colors);
    ctx.fillStyle = css(b); ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = css(a);
    if (tier === 1) {
      const sw = W / 11;
      for (let k = 0; k < 11; k += 2) ctx.fillRect(k * sw, 0, sw, H);
    } else if (tier === 2) {
      const sw = W / 7, L = W + H;
      ctx.save(); ctx.translate(W / 2, H / 2); ctx.rotate(-Math.PI / 4);
      for (let x = -L; x < L; x += sw * 2) ctx.fillRect(x, -L, sw, 2 * L);
      ctx.restore();
    } else {
      const rays = tier === 3 ? 24 : 32, cx = W / 2, cy = H * 0.45, R = W + H;
      for (let k = 0; k < rays; k += 2) {
        const a0 = (k / rays) * 2 * Math.PI, a1 = ((k + 1) / rays) * 2 * Math.PI;
        ctx.beginPath(); ctx.moveTo(cx, cy); ctx.arc(cx, cy, R, a0, a1); ctx.closePath(); ctx.fill();
      }
      const g = ctx.createRadialGradient(cx, cy, Math.min(W, H) * 0.25, cx, cy, Math.max(W, H) * 0.75);
      g.addColorStop(0, 'rgba(0,0,0,0)');
      g.addColorStop(1, tier === 3 ? 'rgba(201,149,44,.5)' : 'rgba(18,16,12,.7)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    }
    const dw = W * 0.92, dh = H * 0.92;
    ctx.imageSmoothingQuality = 'high';
    ctx.shadowColor = 'rgba(0,0,0,.3)'; ctx.shadowBlur = W * 0.02; ctx.shadowOffsetY = W * 0.01;
    ctx.drawImage(cut, (W - dw) / 2, (H - dh) / 2, dw, dh);
    return out;
  }

  // Samme billede i den oploesning det vises i (x skaermens pixeltaethed), mindst 800 px (1.500 paa produktsiden), maks 2000 px.
  function hiRes(img) {
    const shown = img.getBoundingClientRect().width || img.clientWidth || 600;
    // Produktsidens billeder vises ogsaa i zoom, og der er de ca. 1.000 px brede.
    const floor = img.closest('media-gallery') ? 1500 : 800;
    const want = Math.min(2000, Math.max(floor, Math.ceil((shown * (window.devicePixelRatio || 1)) / 200) * 200));
    const url = new URL(img.currentSrc || img.src, location.href);
    url.searchParams.set('width', String(want));
    return new Promise((resolve) => {
      const big = new Image();
      big.decoding = 'async';
      big.onload = () => resolve(big);
      big.onerror = () => resolve(img);
      big.src = url.href;
    });
  }

  // Foerste billede bestemmer farverne for hele produktet, saa et galleri ikke skifter farver fra billede til billede.
  async function treat(img, host, tier, colors) {
    if (img.dataset.grailDone) return colors;
    img.dataset.grailDone = '1';
    const r = sample(img);
    if (!r) return colors;
    if (!colors) {
      colors = r.colors;
      // Produktsiden: farverne paa sektionens wrapper, saa baggrunden kan gaa i fuld bredde.
      // Ogsaa paa sektionen selv, ellers nulstiller [data-grail]-standardfarven dem for rammen og pladen.
      const wrap = host.tagName === 'SECTION' && host.parentElement.classList.contains('shopify-section');
      (wrap ? [host, host.parentElement] : [host]).forEach((el) => {
        el.style.setProperty('--grail-c1', `rgb(${colors[0].join(',')})`);
        el.style.setProperty('--grail-c2', `rgb(${colors[1].join(',')})`);
      });
    }
    if (r.white) {
      const src = await hiRes(img);
      const cut = cutout(src);
      if (!cut) return colors;
      paint(cut, tier, colors).toBlob((blob) => {
        if (!blob) return;
        // srcset med 1x, ellers beholder Chrome taetheden fra temaets srcset og viser billedet som 600 px i stedet for 800.
        const url = URL.createObjectURL(blob);
        // Zoom-visningen viser samme billede (galleriets data-media-id er "<sektion>-<media-id>").
        const media = img.closest('[data-media-id]');
        const id = media && media.dataset.mediaId.split('-').pop();
        const zoom = id ? [...document.querySelectorAll(`product-modal [data-media-id="${id}"] img`)] : [];
        [img, ...zoom].forEach((el) => {
          el.removeAttribute('sizes');
          el.srcset = `${url} 1x`;
          el.src = url;
        });
        host.classList.add('grail--auto');
      }, 'image/webp', 0.93);
    }
    return colors;
  }

  const loaded = (img) => (img.complete && img.naturalWidth
    ? Promise.resolve()
    : new Promise((resolve) => img.addEventListener('load', resolve, { once: true })));

  function init(host) {
    if (host.dataset.grailInit) return;
    host.dataset.grailInit = '1';
    const tier = tierOf(host);
    if (!tier) return;
    const [first, ...rest] = host.querySelectorAll('.card__media img, media-gallery img');
    if (!first) return;
    loaded(first).then(async () => {
      const colors = await treat(first, host, tier, null);
      rest.forEach((img) => loaded(img).then(() => treat(img, host, tier, colors)));
    });
  }

  const scan = () => document.querySelectorAll('[data-grail]:not([data-grail-init])').forEach(init);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; scan(); }, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
